export default __webpack_public_path__ + "static/media/venture_capital_overview.33761496.svg";